<template>
  <div class="container sm">
    <div v-if="isLoading" class="text-center my-3">読み込み中です... <i class="fa-solid fa-spinner fa-spin ms-2"/></div>
    <div v-if="!isLoading">
      <div v-if="selectedUser">
        <div class="fw-bold">
          <span class="nowrap">{{ selectedUser.username }}さんで</span>
          <span class="nowrap">お間違えないですか？</span>
        </div>
        <button
          class="mt-3"
          :class="[styleClasses.submitButton, styleClasses.full]"
          @click="execLogin(selectedUser)">はい</button>
        <button
          class="mt-2"
          :class="[styleClasses.submitButton, styleClasses.border, styleClasses.short, styleClasses.full]"
          @click="selectedUser = null">いいえ</button>
      </div>
      <div v-else>
        <div
          v-if="!sortedDrivers.length"
          class="text-center fw-bold mb-2">
          <span class="nowrap">ドライバーの登録が</span>
          <span class="nowrap">ありません</span>
          <span class="nowrap">管理者に</span>
          <span class="nowrap">お問い合わせください。</span>
        </div>
        <div v-if="sortedDrivers.length" class="text-center fw-bold mb-2">
          <span class="nowrap">ログインするユーザーを</span>
          <span class="nowrap">選択してください</span>
        </div>
        <ul
          v-if="sortedDrivers.length"
          :class="s.drivers">
          <li
            v-for="driver in sortedDrivers"
            :key="driver.id"
            @click="selectedUser = driver"
          >{{ driver.username }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import cf from '@/mixins/commonFunctions';


export default {
  name: 'Login',
  mixins: [cf],
  props: {
    officeId: {
      type: Number,
    },
    type: {
      type: String,
    },
    styleClasses: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      drivers: [],
      selectedUser: null,
    };
  },
  created() {
    this.getDrivers();
  },
  computed: {
    sortedDrivers() {
      if (this.type === 'taxi') return this.drivers.filter((d) => d.role.role === 11);
      if (this.type === 'rideshare') return this.drivers.filter((d) => d.role.role === 13);
      return this.drivers;
    },
  },
  methods: {
    getDrivers() {
      this.isLoading = true;
      const demandAreaIds = this.$store.state.helper.device?.demandAreaIds || [];
      const params = {
        role: [11, 13],
        officeId: this.officeId,
        byDatabase: 1,
        withLatestPositions: 0,
      };
      if (demandAreaIds.length) params.demandAreaIds = demandAreaIds;

      this.axios({
        method: 'GET',
        url: '/v1/user/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.drivers = res.list.data;
        })
        .catch((error) => {
          console.error('Error fetching users:', error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    execLogin(user) {
      if (!user?.id) return;
      const data = {
        loginType: 'onlyId',
        userId: user.id,
      };
      this.$emit('submitLogin', data);
    },

    /** サブミット */
    submit() {
      const data = {
        serialId: `${this.selectedOffice.name}_${this.serialId}`,
        password: this.password,
      };
      this.$emit('submitLogin', data);
    },
  },
};
</script>

<style lang="scss" module>
// ログイン失敗時
.vibration {
  animation: vibration .1s  infinite;
}
@keyframes vibration {
  0% {transform: translate(0px, 0px) rotateZ(0deg)}
  25% {transform: translate(2px, 2px) rotateZ(1deg)}
  50% {transform: translate(0px, 2px) rotateZ(0deg)}
  75% {transform: translate(2px, 0px) rotateZ(-1deg)}
  100% {transform: translate(0px, 0px) rotateZ(0deg)}
}
</style>

<style lang="scss" module="s">
.offices {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  > li {
    width: 10em;
    margin-right: 12px;
    margin-bottom: 12px;
    > input {
      display: none;
    }
    > label {
      padding: 12px;
      cursor: pointer;
      width: 100%;
      border: 1px solid var(--border-gray);
      border-radius: 6px;
      transition: all .3s;
      text-align: center;

      &.checked {
        border-color: var(--primary-lightblue);
        color: var(--primary-lightblue);
        font-weight: bold;
      }
    }
  }
}

.form_wrap {
  display: flex;
  align-items: center;
  > label {
    width: 140px;
  }
  > :nth-child(2) {
    flex: 1;
  }
}

.drivers {
  display: flex;
  flex-wrap: wrap;
  > li {
    width: calc((100% - 12px) / 2);
    padding: 12px;
    border: 1px solid var(--border-gray);
    border-radius: 6px;
    &:nth-child(2n) {
      margin-left: 12px;
    }
    &:nth-child(n + 3) {
      margin-top: 12px;
    }
    &.highlight {
      background-color: var(--bg-gray);
    }
  }
}
</style>
